import { createSelector } from 'reselect';

import { getSelectedDealerId } from '../../selectors/dealerSelectors';
import { getAllLockers, getPlanningUi as getState } from '../lockers/selectors';

export const getLockersCalendar = createSelector(getState, getAllLockers, (state, lockers) =>
  state.lockers.map(locker => ({
    ...locker,
    ...(lockers?.[locker.id] ?? {}),
  })));

const getApp = createSelector(getState, state => state.app);

export const getLockerCalendarById = createSelector(
  getLockersCalendar,
  (_, lockerId) => lockerId,
  (state, lockerId) => state.find(({ id }) => lockerId === id)
);

export const getFilters = createSelector(getState, state => state.filters);

export const getSelectedDate = createSelector(getFilters, filters => filters.date);

export const getParameters = createSelector(
  getFilters,
  getSelectedDate,
  getSelectedDealerId,
  (filters, date, dealerId) => ({
    from: date,
    to: date,
    dealerId,
    filters,
  })
);

const getAppointmentModalState = createSelector(getState, state => state.modal);

export const isCreateAppointmentModalOpen = createSelector(getAppointmentModalState, modal => modal.isOpen);

export const getAppointmentModalProps = createSelector(getAppointmentModalState, modal => modal.props);

export const isLoading = createSelector(getApp, state => state.isLoading);

export const getSingleLockerId = createSelector(getApp, state => state.lockerId);

export const getPersistedFilters = createSelector(getFilters, filters => {
  const { date, ...persisted } = filters;
  return persisted;
});
